import React, { Component } from "react"
import {
  Card,
  Icon,
  Label,
  Segment,
  Form,
  Button,
  Table,
} from "semantic-ui-react"
import { Redirect, withRouter } from "react-router-dom"
import { connect } from "react-redux"
import bind from "bind-decorator"
import { editEmployee } from "../ducks/employees"
import { withTranslation } from "react-i18next"

@withTranslation()
@withRouter
@connect(
  (state) => ({
    employee: state.employees.currentEmployee,
  }),
  (dispatch) => ({
    editEmployee: (...data) => dispatch(editEmployee(...data)),
  }),
)
class EmployeeProfile extends Component {
  state = {
    edit: false,
    id: this.props.employee.id,
    login: this.props.employee.login || "",
    firstName: this.props.employee.firstName || "",
    secondName: this.props.employee.lastName || "",
    middleName: this.props.employee.middleName || "",
    owner: this.props.employee.owner || "",
    roles: this.props.employee.roles,
    storesForRender: this.props.employee.storesForRender,
    stores: this.props.employee.stores,
  }

  @bind
  toEdit() {
    this.setState({ edit: true })
  }

  @bind
  toView() {
    this.setState({ edit: false })
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onChange({}, { value, name }) {
    this.setState({
      ...this.state,
      [name]: value,
    })
  }

  @bind
  onSave() {
    const { editEmployee } = this.props
    const {
      id,
      firstName,
      secondName,
      login,
      middleName,
      roles,
      stores,
    } = this.state
    const data = {
      employeeId: id,
      firstName: firstName,
      lastName: secondName,
      login: login,
      middleName: middleName,
      roles: roles,
      stores: stores,
    }
    editEmployee(data)
    this.setState({ edit: false })
  }

  render() {
    const { t } = this.props
    if (performance.navigation.type === 1) {
      return <Redirect to="/employees" />
    }
    const {
      edit,
      firstName,
      secondName,
      middleName,
      login,
      roles,
      stores,
      storesForRender,
    } = this.state

    let displayRole = []
    for (let i = 0; i < roles.length; i++) {
      displayRole.push(
        this.props.employee.rolesOptions.find((item) => item.id === roles[i]),
      )
    }

    let displayStore = []
    for (let i = 0; i < stores.length; i++) {
      displayStore.push(
        storesForRender.find((item) => item.value === stores[i]),
      )
    }
    return (
      <>
        <a onClick={this.props.history.goBack} style={{ cursor: "pointer" }}>
          <h2>{t("employeesPage")}</h2>
        </a>
        {edit ? (
          <Card fluid as={Segment}>
            <Card.Content>
              <Card.Header>{t("dataChange")}</Card.Header>
              <Form style={{ marginTop: "20px" }}>
                <Form.Input
                  label={t("lastname")}
                  type="text"
                  name="secondName"
                  value={secondName}
                  onChange={this.onChange}
                />
                <Form.Input
                  label={t("firstname")}
                  type="text"
                  name="firstName"
                  value={firstName}
                  onChange={this.onChange}
                />
                <Form.Input
                  label={t("middlename")}
                  type="text"
                  name="middleName"
                  value={middleName}
                  onChange={this.onChange}
                />
                <Form.Input
                  label="Логин"
                  type="text"
                  name="login"
                  value={login}
                  onChange={this.onChange}
                />
                <Form.Select
                  options={this.props.employee.rolesOptions}
                  multiple
                  label={t("roles")}
                  name="roles"
                  value={roles}
                  onChange={this.onChange}
                />
                <Form.Select
                  options={storesForRender}
                  multiple
                  label={t("stores")}
                  name="stores"
                  value={stores}
                  onChange={this.onChange}
                />
              </Form>
              <div style={{ marginTop: "50px" }}>
                <Button basic onClick={this.toView}>
                  {t("cancel")}
                </Button>
                <Button
                  color="green"
                  style={{ marginLeft: "10px" }}
                  onClick={this.onSave}
                >
                  {t("save")}
                </Button>
              </div>
            </Card.Content>
          </Card>
        ) : (
          <Card fluid as={Segment}>
            <Card.Content>
              <Card.Header>
                {secondName} {firstName} {middleName}
                {/* !this.props.employee.isOwner && (
                  <Label attached="top right" as="a" onClick={this.toEdit}>
                    <Icon name="pencil" fitted /> изменить
                  </Label>
                ) */}
              </Card.Header>
              <Table style={{ border: "none" }}>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>Логин: </Table.Cell>
                    <Table.Cell>{login}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell valign="top">{t("roles")}: </Table.Cell>
                    <Table.Cell>
                      {displayRole.map((role) => (
                        <p key={role.id}>{role.name}</p>
                      ))}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("stores")}: </b>
                    </Table.Cell>
                    <Table.Cell>
                      <Table style={{ border: "none" }}>
                        <Table.Body>
                          <Table.Row>
                            <Table.Cell>
                              <b>{t("storeName")}</b>
                            </Table.Cell>
                            <Table.Cell>
                              <b>{t("storeAddress")}</b>
                            </Table.Cell>
                          </Table.Row>
                          {storesForRender.map((store) => (
                            // eslint-disable-next-line react/jsx-key
                            <Table.Row>
                              <Table.Cell key={store.value}>
                                {store.name}
                              </Table.Cell>
                              <Table.Cell key={store.value}>
                                {store.address}
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Card.Content>
          </Card>
        )}
      </>
    )
  }
}

export default EmployeeProfile
